import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { FaUsers, FaUserTie, FaChartBar, FaPeopleArrows, FaBusinessTime, FaTachometerAlt, FaFileAlt, FaBell, FaEnvelope, FaCaretDown, FaRegAddressBook, FaCalendarAlt, FaBullhorn, FaUsersCog, FaHome, FaClipboardList, FaChartLine, FaUserFriends, FaPeopleCarry } from "react-icons/fa";
import { IoHomeOutline, IoMenu } from "react-icons/io5";
import "./Navbar.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from "../../AuthContext/AuthContext";
import { baseURL } from "../../Apiservices/Api";
import { ThemeContext } from "../Themes/ThemeContext";
import logo from '../../Images/Logo-funstay.png';
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Reminderactions from "./../../Pages/Admin/Potentialleads/Reminderactions";

const Manager = ({ onToggleSidebar }) => {
  const [formData, setFormData] = useState({
    imageUrl: "",
  });
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const { themeColor } = useContext(ThemeContext);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [emailNotifications, setEmailNotifications] = useState([]);
  const [showEmailNotificationDropdown, setShowEmailNotificationDropdown] = useState(false);
  const navigate = useNavigate();
  const { logout, userName, userId, authToken } = useContext(AuthContext);

  // Reminder states
  const [reminderAlerts, setReminderAlerts] = useState([]);
  const [pendingAlerts, setPendingAlerts] = useState([]);
  const [showReminderPanel, setShowReminderPanel] = useState(false);
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [selectedTravelOpportunityId, setSelectedTravelOpportunityId] = useState(null);
  const [currentAlertKey, setCurrentAlertKey] = useState(null);
  const [resolvedUserId, setResolvedUserId] = useState(null);

  // Refs for dropdowns
  const reminderPanelRef = useRef(null);
  const emailDropdownRef = useRef(null);
  const profileDropdownRef = useRef(null);

  // Reminder helpers
  const getStoredAlerts = () => {
    try { return JSON.parse(localStorage.getItem("managerShownAlerts") || "[]"); }
    catch { return []; }
  };
  const getStoredPendingAlerts = () => {
    try { return JSON.parse(localStorage.getItem("managerPendingAlerts") || "[]"); }
    catch { return []; }
  };
  const shownAlerts = useRef(new Set(getStoredAlerts()));

  const truncateText = (text, limit = 40) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  useEffect(() => {
    const stored = getStoredPendingAlerts();
    if (stored.length > 0) setPendingAlerts(stored);
  }, []);

  useEffect(() => {
    setResolvedUserId(userId || localStorage.getItem("userId"));
  }, [userId]);

  useEffect(() => {
    localStorage.setItem("managerPendingAlerts", JSON.stringify(pendingAlerts));
  }, [pendingAlerts]);

  const markAlertAsRead = (alertKey) => {
    setPendingAlerts(prev => prev.filter(a => a.key !== alertKey));
  };

  const clearAllAlerts = () => {
    setPendingAlerts([]);
    localStorage.removeItem("managerPendingAlerts");
    shownAlerts.current.clear();
    localStorage.removeItem("managerShownAlerts");
    setShowReminderPanel(false);
  };

  const handleAlertClick = (alertKey, leadid, travelOpportunityId) => {
    setSelectedLeadId(leadid);
    setSelectedTravelOpportunityId(travelOpportunityId);
    setCurrentAlertKey(alertKey);
    setShowReminderModal(true);
  };

  const handleActionSuccess = () => {
    if (currentAlertKey) {
      markAlertAsRead(currentAlertKey);
      setCurrentAlertKey(null);
    }
    setShowReminderModal(false);
    setSelectedLeadId(null);
    setSelectedTravelOpportunityId(null);
  };

  const handleCloseReminderModal = () => {
    setShowReminderModal(false);
    setSelectedLeadId(null);
    setSelectedTravelOpportunityId(null);
    setCurrentAlertKey(null);
  };

  const checkReminders = useCallback(async () => {
    const id = userId || localStorage.getItem("userId");
    if (!id) return;
    try {
      const { data } = await axios.get(`${baseURL}/api/check-reminders`, {
        params: { userId: id },
      });
      const currentPending = getStoredPendingAlerts();
      data.forEach((reminder) => {
        const key = `${reminder.id}-${reminder.label}`;
        const isInPending = currentPending.some((a) => a.key === key);
        if (!shownAlerts.current.has(key) && !isInPending) {
          shownAlerts.current.add(key);
          localStorage.setItem("managerShownAlerts", JSON.stringify(Array.from(shownAlerts.current)));
          const correctLeadId = reminder.lead_id || reminder.leadid;
          const correctTravelOppId = reminder.travel_opportunity_id;
          const newAlert = {
            key,
            reminder,
            leadid: correctLeadId,
            travelOpportunityId: correctTravelOppId,
            message: `${reminder.label}: Lead ${correctLeadId} : Note ${truncateText(reminder.notes)}`,
            timestamp: Date.now(),
          };
          setPendingAlerts((prev) => {
            if (prev.some((a) => a.key === newAlert.key)) return prev;
            return [...prev, newAlert];
          });
          setReminderAlerts((prev) => [...prev, { ...newAlert, isBlinking: true }]);
          setTimeout(() => {
            setReminderAlerts((prev) => prev.filter((a) => a.key !== newAlert.key));
          }, 15000);
        }
      });
    } catch (error) {
      console.error("Error checking reminders:", error);
    }
  }, [userId]);

  useEffect(() => {
    checkReminders();
    const interval = setInterval(checkReminders, 30000);
    return () => clearInterval(interval);
  }, [checkReminders]);

  // Handle outside clicks with refs
  useEffect(() => {
    const handleOutsideClick = (event) => {
      // Check if click is inside any dropdown using refs
      if (reminderPanelRef.current && reminderPanelRef.current.contains(event.target)) {
        return;
      }
      if (emailDropdownRef.current && emailDropdownRef.current.contains(event.target)) {
        return;
      }
      if (profileDropdownRef.current && profileDropdownRef.current.contains(event.target)) {
        return;
      }
      
      // Close all dropdowns if click is outside
      setShowReminderPanel(false);
      setShowEmailNotificationDropdown(false);
      setShowDropdown(false);
    };
    
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
    onToggleSidebar(!collapsed);
  };

  const handleNavItemClick = () => {
    if (window.innerWidth <= 768) {
      setCollapsed(true);
    }
  };

  const handleProfileClick = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      try {
        const response = await fetch(`${baseURL}/employee/${userId}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        const data = await response.json();
        setFormData({
          imageUrl: data.image || "",
        });
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchEmployeeDetails();
  }, [userId, authToken]);
  
  const handleLogout = () => {
    logout();
    console.log('Logged out');
    navigate('/');
  };

  const toggleEmailNotificationDropdown = () => {
    setShowEmailNotificationDropdown(!showEmailNotificationDropdown);
  };

  const fetchEmailNotifications = async () => {
    try {
      const response = await fetch(`${baseURL}/api/manager/email/notifications?managerid=${userId}`);
      const data = await response.json();
      const emails = data.emailnotifications || [];
      setEmailNotifications(emails);
    } catch (error) {
      console.error("Error fetching email notifications:", error);
      setEmailNotifications([]);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchEmailNotifications();
    };

    fetchData();
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, [userId]);

  const markEmailNotificationAsRead = async (emailnotificationId) => {
    try {
      await fetch(`${baseURL}/api/email/notifications/${emailnotificationId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ read: true }),
      });
    } catch (error) {
      console.error("Error marking email notification as read:", error);
    }
  };

  const handleEmailNotificationClick = async (emailnotification) => {
    await markEmailNotificationAsRead(emailnotification.id);
    setEmailNotifications((prev) => prev.filter((n) => n.id !== emailnotification.id));
    setShowEmailNotificationDropdown(false);

    if (emailnotification.leadid) {
      navigate(`/m_email-history/${emailnotification.leadid}`, { state: { email: emailnotification.email } });
    } else {
      navigate('/m-potential-leads');
    }
  };

  return (
    <>
      <div className="manager-container">
        <div className="manager-header" style={{ "--theme-color": themeColor }}>
          <div className="manager-header-left">
            <div
              className={`manager-sidebar-toggle ${collapsed ? 'collapsed' : ''}`}
              onClick={toggleSidebar}
            >
              <IoMenu className="toggle-icon" />
            </div> &nbsp;&nbsp;
            <img src={logo} alt="Logo" className="manager-company-logo" />
          </div>
          <h2 className="text-center user-manager" style={{ color: 'white' }}> {userName ? userName.charAt(0).toUpperCase() + userName.slice(1) : ""} - Manager</h2>

          <div className="manager-header-right">
            <div className="manager-header-icons">
              
              {/* Reminder Bell with ref */}
              <div ref={reminderPanelRef} style={{ position: "relative" }}>
                <div
                  className="admin-nav-icon-container"
                  style={{ position: "relative", cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowReminderPanel(prev => !prev);
                    setShowEmailNotificationDropdown(false);
                    setShowDropdown(false);
                  }}
                >
                  <FaBell className="admin-nav-icon" />
                  {pendingAlerts.length > 0 && (
                    <span className="admin-nav-badge">{pendingAlerts.length}</span>
                  )}
                </div>

                {showReminderPanel && (
                  <div
                    className="notification-dropdown"
                    style={{
                      position: "absolute",
                      top: "calc(100% + 8px)",
                      right: 0,
                      width: 350,
                      background: "#fff",
                      borderRadius: 8,
                      boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                      overflow: "hidden",
                      zIndex: 10001,
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div
                      className="notification-dropdown-header"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "#ff9800",
                        padding: "10px 14px",
                        color: "#fff",
                      }}
                    >
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        Reminders ({pendingAlerts.length})
                      </span>
                      <div style={{ display: "flex", gap: 8 }}>
                        {pendingAlerts.length > 0 && (
                          <button
                            onClick={(e) => { e.stopPropagation(); clearAllAlerts(); }}
                            style={{ background: "#f44336", color: "white", border: "none", padding: "4px 10px", borderRadius: 4, cursor: "pointer", fontSize: 12, fontWeight: "bold" }}
                          >
                            Clear All
                          </button>
                        )}
                        <button
                          onClick={(e) => { e.stopPropagation(); setShowReminderPanel(false); }}
                          style={{ background: "none", border: "none", color: "#fff", fontSize: 18, cursor: "pointer" }}
                        >
                          ✕
                        </button>
                      </div>
                    </div>

                    <div
                      className="notification-dropdown-body"
                      style={{ maxHeight: 300, overflowY: "auto" }}
                    >
                      {pendingAlerts.length === 0 ? (
                        <div className="notification-item" style={{ textAlign: "center", color: "#999", padding: 30 }}>
                          No new reminders
                        </div>
                      ) : (
                        pendingAlerts.map((alert) => (
                          <div
                            key={alert.key}
                            className="notification-item"
                            style={{ padding: "10px 14px", borderBottom: "1px solid #f0f0f0", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}
                          >
                            <div
                              style={{ flex: 1, minWidth: 0, cursor: "pointer" }}
                              onClick={() => resolvedUserId && handleAlertClick(alert.key, alert.leadid, alert.travelOpportunityId)}
                            >
                              <div style={{ fontSize: 13, color: "#333", wordBreak: "break-word" }}>{alert.message}</div>
                              <div style={{ fontSize: 11, color: "#999", marginTop: 2 }}>{new Date(alert.timestamp).toLocaleTimeString()}</div>
                            </div>
                            <button
                              onClick={(e) => { e.stopPropagation(); markAlertAsRead(alert.key); }}
                              style={{ background: "none", border: "none", color: "#bbb", fontSize: 14, cursor: "pointer", padding: "2px 6px" }}
                              title="Dismiss"
                            >✕</button>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>
              
              {/* Email Notifications with ref */}
              <div ref={emailDropdownRef} style={{ position: "relative" }}>
                <div 
                  className="admin-nav-icon-container" 
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleEmailNotificationDropdown();
                  }}
                >
                  <FaEnvelope className="admin-nav-icon" />
                  {(emailNotifications?.length || 0) > 0 && (
                    <span className="admin-nav-badge">{emailNotifications.length}</span>
                  )}
                  {showEmailNotificationDropdown && (
                    <div className="notification-dropdown" onClick={(e) => e.stopPropagation()}>
                      <div className="notification-dropdown-header">Email Notifications</div>
                      <div className="notification-dropdown-body">
                        {(!emailNotifications || emailNotifications.length === 0) ? (
                          <div className="notification-item">No new email notifications</div>
                        ) : (
                          emailNotifications.map((emailnotification) => (
                            <div
                              key={emailnotification.id}
                              className="notification-item"
                              onClick={() => handleEmailNotificationClick(emailnotification)}
                              style={{ padding: "8px", cursor: "pointer" }}
                            >
                              <div style={{ fontWeight: emailnotification.read ? "normal" : "bold" }}>
                                {emailnotification.text?.length > 40
                                  ? `${emailnotification.text.slice(0, 40)}...`
                                  : emailnotification.text}
                              </div>
                              <div style={{ fontSize: "0.8em", color: "#888" }}>
                                {new Date(emailnotification.created_at).toLocaleString('en-IN', {
                                  timeZone: 'Asia/Kolkata',
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  second: '2-digit',
                                  hour12: false
                                })}
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Profile Dropdown with ref */}
              <div ref={profileDropdownRef} style={{ position: "relative" }}>
                <div 
                  className="manager-nav-icon-container" 
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleProfileClick();
                  }}
                >
                  <div className="manager-nav-profile">
                    {formData.imageUrl ? (
                      <img
                        src={`${baseURL}${formData.imageUrl}`}
                        alt="Profile"
                        className="manager-nav-profile-img"
                      />
                    ) : (
                      <img
                        src="https://i.pravatar.cc/100?img=4"
                        alt="Default Profile"
                        className="manager-nav-profile-img"
                      />
                    )}
                    <FaCaretDown className="manager-nav-caret-icon" />
                  </div>
                  {showDropdown && (
                    <div className="manager-nav-profile-dropdown" onClick={(e) => e.stopPropagation()}>
                      <div className="manager-nav-profile-header">
                        <strong> {userName ? userName.charAt(0).toUpperCase() + userName.slice(1) : ""}</strong>
                      </div>
                      <div
                        className="manager-nav-profile-item"
                        onClick={() => navigate("/m-profile")}
                      >
                        Your Profile
                      </div>
                      <div className="manager-nav-profile-item" onClick={handleLogout}>Sign Out</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`manager-sidebar ${collapsed ? 'collapsed' : ''}`} style={{ "--theme-color": themeColor }}>
          <div className="manager-position-sticky">
            <ul className="nav flex-column">
              <li className={`manager-nav-item ${location.pathname.startsWith("/m-dashboard") ? "active" : ""}`}>
                <Link className="nav-link" to="/m-dashboard" onClick={handleNavItemClick}>
                  <FaHome className="manager-nav-icon" />
                  {!collapsed && <span className="link_text">Dashboard</span>}
                </Link>
              </li>

              <li className={`manager-nav-item ${location.pathname.startsWith("/m-allleads") || location.pathname.startsWith("/m-viewallleads") ? "active" : ""}`}>
                <Link className="nav-link" to="/m-allleads" onClick={handleNavItemClick}>
                  <FaUsers className="manager-nav-icon" />
                  {!collapsed && <span className="link_text">All Leads</span>}
                </Link>
              </li>

              <li className={`manager-nav-item ${["/m-view-leads", "/m-edit-lead", "/m-add-leads", "/m-comments", "/m-view-lead", "/m-create-customer-opportunity"].some(path => location.pathname.startsWith(path)) ? "active" : ""}`}>
                <Link className="nav-link" to="/m-view-leads" onClick={handleNavItemClick}>
                  <FaClipboardList className="manager-nav-icon" />
                  {!collapsed && <span className="link_text">My Team Leads</span>}
                </Link>
              </li>

              <li className={`manager-nav-item ${["/m-myleads", "/m-myedit-lead", "/m-myadd-leads", "/m-mycomments", "/m-myview-lead", "/m-mycreate-customer-opportunity"].some(path => location.pathname.startsWith(path)) ? "active" : ""}`}>
                <Link className="nav-link" to="/m-myleads" onClick={handleNavItemClick}>
                  <FaUserTie className="manager-nav-icon" />
                  {!collapsed && <span className="link_text">My Leads</span>}
                </Link>
              </li>

              <li className={`manager-nav-item ${["/m-potential-leads", "/m-edit-opportunity", "/m_email-history", "/m-opportunity-comments", "/m-details", "/m-payments", "/m-add-payment", "/m-supplier", "/m-add-supplier", "/m-suppliers", "/m-suppliers/history", "/m-edit-payment","/m-edit-suppayment"].some(path => location.pathname.startsWith(path)) ? "active" : ""}`}>
                <Link className="nav-link" to="/m-potential-leads" onClick={handleNavItemClick}>
                  <FaChartBar className="manager-nav-icon" />
                  {!collapsed && <span className="link_text">My Team's Opportunities</span>}
                </Link>
              </li>

              <li className={`manager-nav-item ${["/m-myoppleads", "/m-myedit-opportunity", "/m-myopportunity-comments", "/m_myemail-history", "/m-mydetails", "/m-mypayments", "/m-add-mypayment", "/m-mysupplier", "/m-add-mysupplier", "/m-mysuppliers", "/m-mysuppliers/history", "/m-edit-mypayment","/m-edit-mysuppayment"].some(path => location.pathname.startsWith(path)) ? "active" : ""}`}>
                <Link className="nav-link" to="/m-myoppleads" onClick={handleNavItemClick}>
                  <FaChartLine className="manager-nav-icon" />
                  {!collapsed && <span className="link_text">My Opportunities</span>}
                </Link>
              </li>

              <li className={`manager-nav-item ${["/m-customers", "/m-customer-details", "/m-customerdetails", "/m-editcustomerdetails"].some(path => location.pathname.includes(path)) ? "active" : ""}`}>
                <Link className="nav-link" to="/m-customers" onClick={handleNavItemClick}>
                  <FaUserFriends className="manager-nav-icon" />
                  {!collapsed && <span className="link_text">My Team's Customers</span>}
                </Link>
              </li>

              <li className={`manager-nav-item ${location.pathname === "/m-myteam" ? "active" : ""}`}>
                <Link className="nav-link" to="/m-myteam" onClick={handleNavItemClick}>
                  <FaPeopleArrows className="manager-nav-icon" />
                  {!collapsed && <span className="link_text">My Team</span>}
                </Link>
              </li>

              <li className={`admin-nav-item ${location.pathname.startsWith("/M_Report") ? "active" : ""}`}>
                <Link className="nav-link" to="/M_Report" onClick={handleNavItemClick}>
                  <FaFileAlt className="admin-nav-icon" />
                  {!collapsed && <span className="link_text">Report </span>}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Blinking Toast Alerts */}
      {reminderAlerts.length > 0 && (
        <div style={{ position: "fixed", top: 70, right: 20, zIndex: 9998 }}>
          {reminderAlerts.map((alert) => (
            <div
              key={alert.key}
              style={{
                background: "#fff",
                padding: "12px 16px",
                marginBottom: 10,
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                borderLeft: "4px solid #ff9800",
                minWidth: 250,
                cursor: "pointer",
                animation: alert.isBlinking ? "reminderBlink 0.5s ease-in-out 3" : "none",
              }}
              onClick={() => resolvedUserId && handleAlertClick(alert.key, alert.leadid, alert.travelOpportunityId)}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 13 }}>{alert.message}</span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setReminderAlerts((prev) => prev.filter((a) => a.key !== alert.key));
                  }}
                  style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", marginLeft: 10 }}
                >
                  ✕
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Reminder Modal */}
      <Modal
        show={showReminderModal}
        onHide={handleCloseReminderModal}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Reminder Actions - Lead ID: {selectedLeadId}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
          {selectedLeadId && resolvedUserId ? (
            <Reminderactions
              leadid={selectedLeadId}
              travelOpportunityId={selectedTravelOpportunityId}
              userId={resolvedUserId}
              onActionSuccess={handleActionSuccess}
            />
          ) : (
            <div style={{ padding: 20, textAlign: "center", color: "red" }}>
              Error: User ID not available. Please refresh the page.
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* Blink animation */}
      <style>{`
        @keyframes reminderBlink {
          0%, 100% { opacity: 1; background: #fff; }
          50%       { opacity: 0.7; background: #fff3e0; border-left-color: #ff5722; }
        }
      `}</style>
    </>
  );
};

export default Manager;